
import { useEffect, useState } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/contexts/AuthContext';

export const useProfileUpdates = () => {
  const { user } = useAuth();
  const [profileVersion, setProfileVersion] = useState(0);

  useEffect(() => {
    if (!user) return;

    // Listen for profile updates
    const profileChannel = supabase
      .channel('profile-updates')
      .on(
        'postgres_changes',
        {
          event: '*',
          schema: 'public',
          table: 'profiles',
          filter: `id=eq.${user.id}`
        },
        () => {
          console.log('Profile updated, triggering refresh...');
          setProfileVersion(prev => prev + 1);
        }
      )
      .subscribe();

    return () => {
      supabase.removeChannel(profileChannel);
    };
  }, [user]);

  return { profileVersion };
};
